import { Slider, SliderThumb, SliderTrack } from 'react-aria-components';
import { millisecondsInMinute } from '@alltrails/data-formatting/dateConstants';
import { getUTCDateStart } from '../../utils/timeHelpers';
import styles from './TimeScrubber.module.scss';

const minutesInDay = 24 * 60;

type TimeScrubberProps = {
  ariaLabel: string;
  intervalMinutes: number;
  onChange: (utcMs: number) => void;
  selectedUTCMs: number; // Any timezone offsets should already be applied so that we can treat the date as UTC
};

// https://www.figma.com/design/6lD2rWP01sgcuqzuhG6EXK/Conditions-%2F-Overlays-2.0-Web-(Handoff)?node-id=3-9002&m=dev
const TimeScrubber = ({ ariaLabel, intervalMinutes, onChange, selectedUTCMs }: TimeScrubberProps) => {
  const numMarks = minutesInDay / intervalMinutes;
  const startingUTC = getUTCDateStart(selectedUTCMs);
  const selectedIndex = (selectedUTCMs - startingUTC) / (intervalMinutes * millisecondsInMinute);

  return (
    <Slider
      aria-label={ariaLabel}
      className={styles.slider}
      maxValue={numMarks - 1}
      minValue={0}
      onChange={index => {
        onChange(startingUTC + index * intervalMinutes * millisecondsInMinute);
      }}
      value={selectedIndex}
    >
      <SliderTrack className={styles.track}>
        {({ state }) => (
          <>
            <div className={styles.trackFill} style={{ width: `${state.getThumbPercent(0) * 100}%` }} />
            <SliderThumb className={styles.thumb} />
          </>
        )}
      </SliderTrack>
    </Slider>
  );
};

export default TimeScrubber;
